import { render } from "./ClientesList.vue?vue&type=template&id=caf2a81c&scoped=true"
import script from "./ClientesList.vue?vue&type=script&lang=js"
export * from "./ClientesList.vue?vue&type=script&lang=js"

import "./ClientesList.vue?vue&type=style&index=0&id=caf2a81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf2a81c"]])

export default __exports__